import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { usePermissionStore, usePermissionStoreLite } from '@/store/store'
import { getLite, getToken } from '@/utils/auth'
import router from '@/router'
// import { useErrorStore } from '@/store/store'

NProgress.configure({ showSpinner: false })

// let skipNextPermission = false

// router.beforeEach(async (to, from, next) => {
//     console.log(
//     '%c[Router Guard]',
//     'color:#409EFF',
//     'From:', from.fullPath,
//     'To:', to.fullPath,
//     'at', new Date().toISOString()
//     )
//     NProgress.start()

//     // const errorStore = useErrorStore()

//     // if (errorStore.status) {
//     //     const status = errorStore.status
//     //     errorStore.clearError()

//     //     // Redirect to matching error page
//     //     if ([401, 403, 404].includes(status)) {
//     //         return next(`/${status}`)
//     //     } else if (status >= 500) {
//     //         return next('/500')
//     //     }
//     // }

//     const permission = usePermissionStore()
//     const permissionLite = usePermissionStoreLite()
//     const hasToken = getToken()

//     if (!hasToken) {
//         if (to.meta.bypass) return next()
//         return next('/login')
//     }

//     const store = getLite() === 'true' ? permissionLite : permission

//     // ✅ Handle login & root path before permission fetching
//     if (to.path === '/login' || to.path === '/') {
//         const target = getLite() === 'true'
//             ? '/gps-tracking/full-map-tracking-lite'
//             : '/gps-tracking/full-map-tracking'
//         return next(target)
//     }

//     let permissionsData = null
//     if (!skipNextPermission) {
//         if (getLite() !== 'true') {
//             console.log(
//             '%cCalling getPermission()',
//             'color:#E6A23C',
//             'isRoutesReady:', permission.isRoutesReady,
//             'skipNextPermission:', skipNextPermission
//             )
//             permissionsData = await permission.getPermission()
//         }
//     } else {
//         skipNextPermission = false // reset
//     }

//     if (!store.isRoutesReady) {
//         let accessRoutes = []
//         if (getLite() === 'true') {
//             accessRoutes = await permissionLite.generateRoutes()
//         } else {
//             accessRoutes = await permission.generateRoutes(permissionsData)
//         }

//         if (accessRoutes.length > 0) {
//             accessRoutes.forEach(route => {
//                 if (!router.hasRoute(route.name)) {
//                     router.addRoute(route)
//                 }
//             })
//             router.addRoute({
//                 path: '/:pathMatch(.*)*',
//                 redirect: '/404'
//             })
//         }
//         // console.log(

//         store.isRoutesReady = true
//         skipNextPermission = true
//         return next({ ...to, replace: true })
//     }
//     if (to.query.backPage) {
//         to.meta.backPage = to.query.backPage
//     }
//     next()
// })

// `[Router Guard] to: ${to.fullPath} from: ${from.fullPath} time: ${Date.now()}`
// )

let isFetchingPermission = false

function isBypassRoute(to) {
    if (to.meta?.bypass) return true
    if (to.matched?.some((record) => record.meta?.bypass)) return true
    const path = to.path || ''
    return (
        path.includes('/sharableLink') ||
        path.includes('/sharableLiveVideoLink') ||
        path.includes('/safevision-intercom') ||
        path.includes('/video-player')
    )
}

router.beforeEach(async (to, from, next) => {
    // console.log(
    //     '%c[Router Guard]',
    //     'color:#409EFF',
    //     'From:', from.fullPath,
    //     'To:', to.fullPath,
    //     'at', new Date().toISOString()
    // )

    NProgress.start()

    // Public pages (same as sharableLink): never call getAccess
    if (isBypassRoute(to) && to.path !== '/login' && to.path !== '/') {
        return next()
    }

    const hasToken = getToken()
    if (!hasToken) {
        if (isBypassRoute(to)) return next()
        return next('/login')
    }

    const store = getLite() === 'true'
        ? usePermissionStoreLite()
        : usePermissionStore()

    // ✅ Handle root/login early
    // if (to.path === '/login' || to.path === '/') {
    //     const target = getLite() === 'true'
    //     ? '/gps-tracking/full-map-tracking-lite'
    //     : '/gps-tracking/full-map-tracking'
    //     return next(target)
    // }
    if (to.path === '/login' || to.path === '/') {
        let target = getLite() === 'true'
        ? '/gps-tracking/full-map-tracking-lite'
        : '/gps-tracking/full-map-tracking'

        if (getLite() !== 'true') {
        const permissionsData = await store.getPermission()

        if (permissionsData.includes('vehicle_tracking_list_enable')) {
            target = '/gps-tracking/full-map-tracking'
        } else if (permissionsData.includes('kpi_dashboard')) {
            target = '/kpi/kpi-dashboard'
        } else {
            target = '/report/report-list'
        }
        }

        return next(target)
    }

    // ✅ Prevent concurrent requests (e.g., when guard triggers twice fast)
    if (isFetchingPermission) {
        // console.log('%cSkipping duplicate permission fetch', 'color:#67C23A')
        return next()
    }

    isFetchingPermission = true

    try {
        // ✅ Always call getPermission() on each navigation
        // console.log('%cCalling getPermission()', 'color:#E6A23C')
        let permissionsData = null

        if (getLite() !== 'true') {
        permissionsData = await store.getPermission()
        }

        // ✅ Only regenerate routes if necessary (not required every time)
        if (!store.isRoutesReady) {
        const accessRoutes = getLite() === 'true'
            ? await store.generateRoutes()
            : await store.generateRoutes(permissionsData)

        accessRoutes.forEach(route => {
            if (!router.hasRoute(route.name)) {
            router.addRoute(route)
            }
        })

        router.addRoute({ path: '/:pathMatch(.*)*', redirect: '/404' })
        store.isRoutesReady = true

        // ✅ Re-match routes once, safe and needed
        return next({ ...to, replace: true })
        }

        // ✅ Normal route navigation after permission fetch
        next()
    } catch (err) {
        console.error('Permission setup failed:', err)
        next('/500')
    } finally {
        isFetchingPermission = false
    }
})

router.afterEach(() => {
    NProgress.done()
})

// import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css' // progress bar style
// import { usePermissionStore, usePermissionStoreLite } from '@/store/store'
// import { getLite } from '@/utils/auth'

// NProgress.configure({ showSpinner: false }) // NProgress Configuration

// import router from '@/router'
// import { getToken } from '@/utils/auth'
// // import { ElNotification } from "element-plus"
// // import i18n from "@/local/i18n.js"

// router.beforeEach(async (to, from, next) => {
//     // start progress bar
//     NProgress.start()

//     const permission = usePermissionStore()
//     const permissionLite = usePermissionStoreLite()

//     const hasToken = getToken()
//     if (hasToken) {
//         if (to.path === '/login' || to.path === '/') {
//             if (getLite() === 'true') {
//                 next({ path: '/gps-tracking/full-map-tracking-lite' })
//             } else {
//                 // next({ path: '/gps-tracking/full-map-tracking' })
//                 next({ path: '/gps-tracking/full-map-tracking' })
//             }
//             NProgress.done()
//         } else {
//             let access = null
//             let permissionGenerated = false
//             if(getLite()==='true'){
//                 access = permissionLite.routes
//                 permissionGenerated = permissionLite.isRoutesReady
//             } else{
//                 access = permission.routes
//                 permissionGenerated = permission.isRoutesReady
//             }
//             if (access.length > 0 && permissionGenerated) {
//                 if(getLite()==='true'){
//                 permissionLite.isRoutesReady = false
//             } else{
//                 permission.isRoutesReady = false
//             }
//                 next()
//             } else {
//                 // const permissions = await permission.getPermission()
//                 let accessRoutes = null
//                 if(getLite()==='true'){
//                     accessRoutes = await permissionLite.generateRoutes()
//                 }else{
//                     const permissions = await permission.getPermission()
//                     accessRoutes = await permission.generateRoutes(permissions)
//                 }
//                 if (accessRoutes.length > 0) {
//                     // dynamically add accessible routes
//                     accessRoutes.forEach(route => {
//                         if (!router.hasRoute(route.name)) {
//                             router.addRoute(route)
//                         }
//                     })
//                     router.addRoute({
//                         path: '/:pathMatch(.*)',
//                         redirect: '/404'
//                     })
//                     // await router.replace(router.currentRoute.value.fullPath)
//                 }
//                 if(getLite()==='true'){
//                     permissionLite.isRoutesReady = true
//                 }else{
//                     permission.isRoutesReady = true
//                 }
//                 next({ ...to, replace: false })
//             }
//         }
//     } else {
//         if (to.meta.bypass) {
//             next()
//         } else {
//             next('login')
//         }
//     }
// })

// router.afterEach(() => {
//     // finish progress bar
//     NProgress.done()
// })